"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.21.0", "build_date": "2026-08-11T10:08:09.526Z", "build_branch": "main", "build_commit": "dc1b2a1a4161c090031c09b14f24e678c89560a5" };
//# sourceMappingURL=build_data.js.map